<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Orden de Pago con Cargo a Gasto de Representación</h2>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tipo de actividad">
            <b-form-radio-group
              data-cy="type-activity"
              v-model="formData.typeActivity"
              :options="optionsTypeActivity"
              name="typeActivity"
              stacked
            />
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Motivo *">
            <b-form-textarea
              :state="errors.has('custom-document.reason') ? false : null"
              data-cy="reason"
              data-vv-as="motivo"
              name="reason"
              maxLength="5000"
              rows="3"
              type="text"
              v-model="formData.reason"
              v-validate="'required'"
            />
            <div class="row justify-content-between">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.has('custom-document.reason')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                >
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.reason') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <small v-tooltip="'Contador de caracteres'">
                  {{formData.reason.length}}/5000
                </small>
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-2">
      <div class="row mb-3">
        <div class="col-md-12">
          <h4>Documentos *</h4>
        </div>
        <div class="col-md-12 mt-3">
          <add-document @add-document="addDocument" />
        </div>
        <div class="col-md-12 mt-3">
          <table-documents
            :documents="formData.documents"
            v-model="formData.documentsSelected"
            multiple
          />
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-md-12">
        <div class="row align-items-center mt-5">
          <div class="col-md-12">
            <label>Adjuntos</label>
          </div>
          <div class="col-md-3 align-items-end">
            <UploadFile
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsx, .ppt"
              text="Seleccionar documentos"
              v-model="fileOthers"
              upload-to="ed"
              :button-class="{ 'btn-block': true,
                 'mb-5': errors.has('custom-document.fileName') }"
              container-class="w-100"
              @input="addOthersFile()"
            />
          </div>
        </div>
        <div class="row align-items-center mt-1">
          <div class="col-md-3 align-items-end">
            <b-button
              variant="secondary"
              class="btn-icon mt-1"
              data-cy= "from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-file-repository'"
            >
              <feather-icon icon="ServerIcon"/>
              Desde el repositorio
            </b-button>
          </div>
          <div class="col-2" v-for="file in formData.attachments" :key="file.id">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="45px" color="primary" />
              <b class="text-truncate w-100 text-center">{{ file.name }}</b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                @click="removeOthersFile(file.id)"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-if="!!error.messageOthers"
              class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-left"
            >
                <span class="span-text-validation">
                  {{ error.messageOthers }}
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="error.message !== ''"
      class="con-text-validation span-text-validation-danger
            vs-input--text-validation-span v-enter-to text-right"
      style="height: 32px;"
    >
      <span class="span-text-validation">
        {{ error.message }}
      </span>
    </div>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
    <!--<SelectDocRepository
      :add-file="addFileRepo"
      :files="formData.attachments"
      :remove-file="removeOthersFile"
    />-->
    <repository-selector
      modal-id="add-file-repository"
      :add-file="addFileRepo"
      :files="formData.attachments"
      :remove-file="removeOthersFile"
    />
  </div>
</template>
<script>
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import AddDocument from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/AddDocument';
import TableDocuments from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/TableDocuments';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'ODP',
  data() {
    return {
      fileOthers: {},
      formData: {
        typeActivity: 1,
        reason: '',
        documents: [],
        documentsSelected: [],
        attachments: []
      },
      error: {
        message: ''
      },
      optionsTypeActivity: [
        {
          value: 1,
          text: 'Manifestaciones (inauguraciones, Fiestas de Aniversario, Celebraciones, etc.) '
            + 'con presencia de autoridades superiores.'
        },
        {
          value: 2,
          text: 'Presente o Atención a autoridades, delegaciones, huéspedes ilustres u otros análogos, '
            + 'en representación del servicio.'
        },
        {
          value: 3,
          text: 'Reunión con representantes de entidades u organizaciones públicas o privadas.'
        }
      ],
      saving: false
    };
  },
  components: {
    RepositorySelector,
    SelectDocRepository,
    UploadFile,
    AddDocument,
    TableDocuments
  },
  methods: {
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.attachments.push(file);
      this.error.message = '';
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.attachments.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async addDocument(row) {
      this.error.message = '';
      this.formData.documents.push(row);
      this.formData.documentsSelected.push(row);
    },
    async validateFormODF(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async generatePdfODF(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('ODP', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    async save() {
      const isValid = await this.validateFormODF('custom-document');
      if (!isValid) {
        return;
      }

      if (!this.formData.documentsSelected.length) {
        this.error.message = 'Debes agregar al menos un documento';
        return;
      }

      this.error.message = '';
      this.saving = true;
      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            numerar: 'si',
            ...this.$route.query
          },
          formData: {
            ...this.formData,
            typeActivity: this.optionsTypeActivity
              .filter((option) => option.value === this.formData.typeActivity)[0].text
          }
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdfODF(response.data.document.id);
      } finally {
        this.saving = true;
      }
    },
    maxLength(value) {
      return String(value).substring(0, 15);
    }
  }
};
</script>
